"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressListDialog = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const Base_1 = require("../../../model/Base");
require("../../List/List");
const ExternalInput_1 = require("./ExternalInput");
const _ = require("underscore");
/**
* Adresslist dialog (mailext.28)
*/
class AddressListDialog extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.m_toEntries = [];
        this.windowWidth = 800;
        this.windowHeight = 600;
        this.windowContentCssClass = "eiAddressListDialog";
        this.windowActions = ["Maximize", "Close"];
        this.needServerConfig = false;
        if (this.input.field.treatAsSingleValue)
            this.multiValue = false;
    }
    getUpdatedInstance() {
        let that = this;
        let updatedInstance = this.currentInstance;
        const values = this.m_$toList.synList("getItems").map(di => di["rfc822"]);
        if (that.multiValue)
            updatedInstance.items[that.input.field.fieldName].value = values;
        else
            updatedInstance.items[that.input.field.fieldName].value = values.join(";");
        return Promise.resolve(updatedInstance);
    }
    initWindowContents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            const markup = require("../../../templates/externalInputs/AddressListDialog.tmpl.html");
            const template = kendo.template(markup);
            const tmpl = template({
                synUtil: Utilities_1.synUtil,
                readOnly: this.input.readonlyForExtInput
            });
            that.widgetContainer.html(tmpl);
            that.m_$fromList = that.widgetContainer.find(".fromList");
            that.m_$toList = that.widgetContainer.find(".toList");
            //that.m_$searchButton = that.widgetContainer.find(".toList");
            that.m_$upButton = that.widgetContainer.find(".upButton");
            that.m_$downButton = that.widgetContainer.find(".downButton");
            that.m_$addCustomEntryButton = that.widgetContainer.find(".addCustomEntryButton");
            that.m_$searchFieldBox = that.widgetContainer.find(".searchFieldBox");
            that.m_$repositionUpButton = that.widgetContainer.find(".repositionUpButton");
            that.m_$repositionDownButton = that.widgetContainer.find(".repositionDownButton");
            that.m_$searchFieldsDiv = that.widgetContainer.find(".searchFieldsDiv");
            that.m_$buttonDiv = that.widgetContainer.find(".buttonDiv");
            that.m_$splitter = that.widgetContainer.find(".splitter");
            that.windowData.windowDiv.data("kendoWindow")
                .setOptions({
                resizable: true,
                minWidth: typeof that.windowMinWidth === "undefined" ? that.windowWidth : that.windowMinWidth,
                minHeight: typeof that.windowMinHeight === "undefined" ? that.windowHeight : that.windowMinHeight
            });
            if (that.input.readonlyForExtInput) {
                that.widgetContainer.find(".toListDiv").css("height", "100%");
                //$("#" + idData.splitter).find("#" + idData.toList).css("height", "100%");
            }
            else {
                that.m_$splitter.kendoSplitter({
                    orientation: "vertical",
                    panes: [
                        { size: "50%", min: "20px", scrollable: false, resizable: true },
                        { size: "33%", min: "20px", scrollable: true, resizable: true },
                    ]
                });
            }
            that.m_$downButton.click(() => {
                that.addSelectedEntries();
            });
            that.m_$upButton.click(() => {
                that.removeSelectedEntries();
            });
            that.m_$addCustomEntryButton.click(() => {
                that.addCustomEntry();
            });
            yield this.createFromListAsync();
            yield this.createToListAsync();
            // set filter handler
            that.m_$searchFieldBox.on("keyup", _.debounce(() => {
                that.m_searchText = that.m_$searchFieldBox.val();
                that.m_$fromList.synList("refresh");
            }, 120));
            // init reposition buttons
            that.m_$repositionUpButton.click(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield that.repositionItemsAsync(true);
            }));
            that.m_$repositionDownButton.click(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield that.repositionItemsAsync(false);
            }));
        });
    }
    repositionItemsAsync(up) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Put all before first or after last selected item
            const selectedIds = this.m_$toList.synList("getSelectedIds");
            if (selectedIds.length) {
                const allIds = this.m_toEntries.map(e => e.id);
                const selectedIndexes = selectedIds.map(id => allIds.indexOf(id));
                const targetIdx = up ? selectedIndexes[0] - 1 : selectedIndexes[selectedIndexes.length - 1] + 2;
                if (targetIdx < 0 || targetIdx > allIds.length)
                    return;
                let arr = [];
                if (up) {
                    selectedIndexes
                        .slice()
                        .reverse()
                        .forEach(idx => { arr.unshift(this.m_toEntries.splice(idx, 1)[0]); });
                    this.m_toEntries.splice(targetIdx, 0, ...arr);
                }
                else {
                    const insertArr = selectedIndexes.map(idx => this.m_toEntries[idx]);
                    this.m_toEntries.splice(targetIdx, 0, ...insertArr);
                    selectedIndexes
                        .slice()
                        .reverse()
                        .forEach(idx => { this.m_toEntries.splice(idx, 1); });
                }
                yield this.m_$toList.synList("refreshAsync");
                yield this.m_$toList.synList("select", ...selectedIds);
            }
        });
    }
    createFromListAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            that.windowData.beginInit();
            try {
                yield that.m_$fromList
                    .synList({
                    columnOptions: {
                        layoutName: "AddressListDialog\\fromlist",
                        windowNameDependent: true,
                        layoutTemplate: [{
                                fieldTitle: Utilities_1.synUtil.Strings.getValue("AddressListDialog.rfc822", "Name"),
                                fieldName: "rfc822",
                                fieldType: Base_1.FieldType.String,
                                fieldConstraint: 0,
                                seqNum: 0
                            },
                            {
                                fieldName: "displayName",
                                fieldTitle: Utilities_1.synUtil.Strings.getValue("AddressListDialog.name", "Name"),
                                fieldType: Base_1.FieldType.String,
                                fieldConstraint: 1,
                                seqNum: 1
                            },
                            {
                                fieldTitle: "objectguid",
                                fieldName: "objectguid",
                                fieldType: Base_1.FieldType.String,
                                fieldConstraint: 0,
                                seqNum: 2
                            },
                            {
                                fieldName: "mail",
                                fieldTitle: Utilities_1.synUtil.Strings.getValue("AddressListDialog.mail", "Mail"),
                                fieldType: Base_1.FieldType.String,
                                fieldConstraint: 1,
                                seqNum: 3
                            }]
                    },
                    sortableCols: true,
                    filterableCols: false,
                    reorderableCols: false,
                    resizableCols: false,
                    dataItemGenerator: () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield that.getGlobalAddressEntriesAsync(); }),
                    autoBind: false,
                    selectionMode: (that.multiValue ? "Multiple" : "Single"),
                    showIcons: false,
                });
                that.windowData.endInit();
                yield that.m_$fromList.synList("refreshAsync");
            }
            finally {
                that.windowData.endInit();
            }
            that.selectFirstRow();
        });
    }
    createToListAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            that.initToEntries();
            yield that.m_$toList.synList({
                columnOptions: [{
                        dataField: "rfc822",
                        dbColType: "string",
                        multiValue: false,
                        sortSeq: 0,
                        title: Utilities_1.synUtil.Strings.getValue("AddressListDialog.rfc822", "Name"),
                        sortDirection: "none",
                        width: 300
                    }],
                sortableCols: false,
                filterableCols: false,
                reorderableCols: false,
                resizableCols: false,
                dataItemGenerator: () => {
                    return new Promise((resolve) => {
                        resolve(that.m_toEntries);
                    });
                },
                selectionMode: (that.multiValue ? "Multiple" : "Single"),
                showIcons: false,
            });
        });
    }
    initToEntries() {
        const that = this;
        const field = that.currentInstance.items[that.input.field.fieldName];
        if (!field.isEmpty) {
            if (that.multiValue)
                that.currentInstance.items[that.input.field.fieldName].valueAsStringArray
                    .forEach(rfc822 => { that.m_toEntries.push(this.rfc822ToCustomListItem(rfc822)); });
            else
                that.m_toEntries.push(this.rfc822ToCustomListItem(that.currentInstance.items[that.input.field.fieldName].valueAsString));
        }
    }
    getGlobalAddressEntriesAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            if (!that.m_globalAddressEntries) {
                that.m_globalAddressEntries = (yield Utilities_1.synUtil.getAJAXDataAsync({
                    url: Utilities_1.synUtil.getWSUrl("IntegrationGetGlobalAdressList"),
                }))
                    .map((result) => {
                    let listDataItem = {
                        id: that.generateRFC822Name(result)
                    };
                    listDataItem[AddressListDialog.UniqueField.toLowerCase()] = listDataItem.id;
                    for (let prop in result)
                        listDataItem[prop.toLowerCase()] = result[prop];
                    return listDataItem;
                });
            }
            return that.m_globalAddressEntries
                .filter(entry => !that.m_searchText || entry.id.toLowerCase().indexOf(that.m_searchText.toLowerCase()) >= 0);
        });
    }
    selectFirstRow() {
        const items = this.m_$fromList.synList("getItems").map(item => item.id);
        if (items.length)
            this.m_$fromList.synList("select", items[0]);
    }
    generateRFC822Name(item) {
        let rfc822 = "";
        if (item.mail) {
            if (item.displayName.indexOf("@") === -1)
                rfc822 = item.displayName;
            rfc822.replace("\'", "");
            rfc822.trim();
            if (item.mail.toLowerCase() !== rfc822.toLowerCase())
                rfc822 += " <" + item.mail + ">";
        }
        return rfc822;
    }
    rfc822ToCustomListItem(rfc822) {
        return {
            "id": rfc822,
            "mail": rfc822,
            "displayname": rfc822,
            "rfc822": rfc822,
            "objectguid": Utilities_1.synUtil.getGUID(false)
        };
    }
    addCustomEntry() {
        let value = this.m_$searchFieldBox.val();
        if (value)
            this.tryAddEntryCore(this.rfc822ToCustomListItem(value));
    }
    tryAddEntryCore(entry) {
        if (this.multiValue) {
            const alreadyExists = this.alreadyExistsInToList(entry.id);
            if (!alreadyExists)
                this.m_toEntries.push(entry);
            return !alreadyExists;
        }
        else {
            this.m_toEntries = [entry];
            return true;
        }
    }
    alreadyExistsInToList(id) {
        const alreadyExistingIdx = this.m_$toList.synList("getItems")
            .map(item => item.id)
            .findIndex(itemId => itemId === id);
        return alreadyExistingIdx >= 0;
    }
    addSelectedEntries() {
        let selected = this.m_$fromList.synList("getSelectedItems");
        if (selected.length >= 1)
            selected.forEach(sel => { this.tryAddEntryCore(sel); });
        else
            this.addCustomEntry();
        this.m_$toList.synList("refresh");
    }
    removeSelectedEntries() {
        let mapIds = {};
        this.m_$toList.synList("getSelectedIds")
            .forEach(id => { mapIds[id] = true; });
        for (let i = this.m_toEntries.length - 1; i >= 0; --i)
            if (mapIds[this.m_toEntries[i].id])
                this.m_toEntries.splice(i, 1);
        this.m_$toList.synList("refresh");
    }
    destroyWidgets() {
        if (this.m_$splitter.data("kendoSplitter"))
            this.m_$splitter.data("kendoSplitter").destroy();
        this.m_$fromList.synList("destroy");
        this.m_$toList.synList("destroy");
    }
}
exports.AddressListDialog = AddressListDialog;
AddressListDialog.UniqueField = "rfc822";
